import { SgComponentIcon } from '../../display/ComponentIcon';
import { SgButton } from '../SgButton';
import { useSgPickerInputContext } from './context';

export function DropdownIndicator() {
  const { size, isOpen, getToggleButtonProps, readonly, disabled } = useSgPickerInputContext();

  return (
    <SgButton
      {...getToggleButtonProps()}
      className="sg-picker-min-h-100 dropdown-indicator"
      size={size}
      iconPosition="icon-only"
      purpose="flat"
      color="none"
      aria-label="Open picker"
      disabled={disabled || readonly}
    >
      <div className="d-flex align-items-center justify-content-center sg-picker-indicator">
        <SgComponentIcon icon={isOpen ? 'arrow_drop_up' : 'arrow_drop_down'} size={size} />
      </div>
    </SgButton>
  );
}

export function LoadingIndicator() {
  const { size, getToggleButtonProps, readonly, disabled } = useSgPickerInputContext();

  return (
    <SgButton
      {...getToggleButtonProps()}
      size={size}
      iconPosition="start"
      className={'btn-icon d-flex flex-center h-100 loading dropdown-indicator'}
      purpose="flat"
      color="none"
      aria-label="Open picker"
      disabled={disabled || readonly}
      loading
    />
  );
}
